module.exports = __webpack_public_path__ + "img/Sycamore PPP v3.53fc2fae.png";